import React from 'react';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation-10';
import { Field } from 'react-final-form';
import { FieldValidator, firstLastNameRegex, firstLastNameRegexErrorText } from '../../../validation/validation';
import { FIRST_NAME } from '../../../constants/formFieldNames';

export default function FirstNameField() {
  return (
    <Field
      name={FIRST_NAME}
      format={(firstName) => firstName?.trim()}
      formatOnBlur
      render={({ input, meta }) => {
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);

        return (
          <FormField
            error={isInvalid}
            label={<Label>Legal first name</Label>}
            control={<Input {...input} />}
            description={isInvalid && <FormHelp>{error}</FormHelp>}
          />
        );
      }}
      validate={(firstName) => {
        const errors = new FieldValidator(firstName)
          .required('Enter a first name')
          .maxLength(32)
          .regex(firstLastNameRegex, firstLastNameRegexErrorText)
          .build();

        return errors ? errors : null;
      }}
    />
  );
}
